import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalCreditControlService } from "services/ClientPortalCreditControlService";
import { CreditControlStatusModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  CreditControlStatus: new CreditControlStatusModel(),
  Loading: false,
};

export const CreditControlStatusSummariesSlice = createSlice({
  name: "CreditControlUnitSummaries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCreditControlStatusSummaries.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCreditControlStatusSummaries.fulfilled, (state, action) => {
        state.CreditControlStatus = action.payload;
        state.Loading = false;
      })
      .addCase(getCreditControlStatusSummaries.rejected, (state) => {
        state.CreditControlStatus = new CreditControlStatusModel();
        state.Loading = false;
      });
  },
});

export const getCreditControlStatusSummaries = createAsyncThunk<CreditControlStatusModel, { developmentID: string }>(
  "CreditControlStatusSummaries/GetCreditControlStatusSummaries",
  async ({ developmentID }) => {
    const creditControlService = container.get<IClientPortalCreditControlService>(
      SERVICE_TYPES.CPLClientPortalCreditControlService
    );
    return await creditControlService.getCreditControlStatusSummaries(developmentID);
  }
);

export const selectCreditControlStatusSummaries = (state: RootState) =>
  state.CreditControlStatusSummaries.CreditControlStatus;
export const selectLoadingCreditControlStatusSummaries = (state: RootState) =>
  state.CreditControlStatusSummaries.Loading;

export default CreditControlStatusSummariesSlice.reducer;
